import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import styled from 'styled-components';

interface IProps {
  bsPrefix?: string; // Add className as an optional prop
  tooltipText?: string; // The text to display inside the tooltip
  children: any; // The children element that will trigger the tooltip
  placement?: 'top' | 'right' | 'bottom' | 'left'; // Add placement as an optional prop
}
const OverlayTriggerWrapper = styled.div`
  .tooltip-inner {
    /* max-width: 30%; */
    word-break: break-word;
  }
`;

const StyledTooltip: React.FC<IProps> = ({ tooltipText = '', children = '', placement = 'top' }) => {
  return (
    <OverlayTriggerWrapper>
      <OverlayTrigger
        placement={placement}
        // show={true} //Set this to true to always show the tooltip
        // defaultShow={true}
        overlay={
          <Tooltip
            id="tooltip-top"
            //  bsPrefix={'custom-tooltip ' + bsPrefix}
          >
            {tooltipText}
          </Tooltip>
        }
      >
        {children}
      </OverlayTrigger>
    </OverlayTriggerWrapper>
  );
};

export default StyledTooltip;
